import { render, staticRenderFns } from "./WeightsSettings.vue?vue&type=template&id=4e2d389f&scoped=true"
import script from "./WeightsSettings.vue?vue&type=script&lang=js"
export * from "./WeightsSettings.vue?vue&type=script&lang=js"
import style0 from "./WeightsSettings.vue?vue&type=style&index=0&id=4e2d389f&prod&scoped=true&lang=css"
import style1 from "./WeightsSettings.vue?vue&type=style&index=1&id=4e2d389f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2d389f",
  null
  
)

export default component.exports